import { FC } from "react";
import { Avatar, Box, Typography } from "@mui/material";
import theme from "@/theme";
import CloseBGGreySvg from "@/assets/svg/CloseBGGreySvg";
import { useAppSelector } from "@/hooks/useAppSelector";

interface IPostHeaderProps {
  handleClose: () => void;
  invalidCashtags: string[];
}

const PostHeader: FC<IPostHeaderProps> = ({ handleClose, invalidCashtags }) => {
  const { user } = useAppSelector((state) => state.auth);
  const getTruncatedCashtagsText = (tags: string[], maxLength = 65) => {
    const joined = tags.join(" ");
    if (joined.length <= maxLength) return joined;

    let result = "";
    for (let tag of tags) {
      if ((result + tag).length + 1 > maxLength) break;
      result += (result ? " " : "") + tag;
    }

    return result + " ...";
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        gap: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Avatar src={user?.image?.url || ""} alt="Profile" sx={{ width: 48, height: 48 }} />
        <Box sx={{ marginLeft: "0.5rem" }}>
          <Typography variant="h6" fontWeight={600}>
            {user?.username}
          </Typography>
        </Box>
      </Box>

      {invalidCashtags.length > 0 && (
        <Box sx={{ flexGrow: 1, textAlign: "center" }}>
          <Typography
            color={theme.palette.error.main}
            variant="h5"
            fontWeight={700}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            Invalid cashtag{invalidCashtags.length > 1 ? "s" : ""}:{" "}
            {getTruncatedCashtagsText(invalidCashtags)}
          </Typography>
        </Box>
      )}

      <Box onClick={handleClose} sx={{ marginTop: "-1rem", cursor: "pointer" }}>
        <CloseBGGreySvg width="26px" height="26px" />
      </Box>
    </Box>
  );
};

export default PostHeader;
